import Link from 'next/link'
import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { MyImage } from '~/components/ui/MyImage'
import { getNewProductList_itemModule_productList } from '~/graphqls/types'

const StyledCreateModule = styled.div`
  overflow: hidden;
  .create-module {
    display: flex;
    flex-wrap: nowrap;
    transition: all 0.3s ease;
    &.create-module-one {
      transform: translateX(-20px);
    }
    &.create-module-two {
      transform: translateX(-100px);
    }

    .create-item {
      width: 192px;
      height: 192px;
      margin-right: 32px;
      margin-bottom: 32px;
    }
    .create-item-thumb {
      display: block;
      width: 192px;
      height: 192px;
      border-radius: 16px;
    }
  }
`

export const CreateModule: React.FC<{
  data: getNewProductList_itemModule_productList[]
}> = ({ data }) => {
  const [active, setActive] = useState(false)
  const [offsetX, setOffsetX] = useState(0)

  const [oneRowData, setOneRowData] = useState(
    data.slice(0, Math.floor(data.length / 2))
  )
  const [twoRowData, setTwoRowData] = useState(
    data.slice(Math.floor(data.length / 2), data.length)
  )

  useEffect(() => {
    let timer: ReturnType<typeof setInterval>
    if (active) {
      timer = setInterval(() => {
        setOffsetX(offsetX => offsetX + 1)
        if (offsetX > 0 && offsetX % 1000 === 0) {
          setOneRowData(rowData => [
            ...rowData,
            ...data.slice(0, Math.floor(data.length / 2)),
          ])
          setTwoRowData(rowData => [
            ...rowData,
            ...data.slice(Math.floor(data.length / 2), data.length),
          ])
        }
      }, 100)
    }

    return () => {
      clearInterval(timer)
    }
  }, [active, data, offsetX])

  return (
    <StyledCreateModule
      onMouseEnter={() => setActive(true)}
      onMouseLeave={() => setActive(false)}
    >
      <div
        className="create-module create-module-one"
        style={{
          transform: `translateX(-${20 + offsetX}px)`,
        }}
      >
        {oneRowData.map((item, index) => (
          <div className="create-item" key={index}>
            <Link href={`/product/${item.id}`}>
              <a>
                <MyImage
                  tag="v400"
                  className="create-item-thumb"
                  src={item.artworkUrl}
                />
              </a>
            </Link>
          </div>
        ))}
      </div>
      <div
        className="create-module create-module-two"
        style={{
          transform: `translateX(-${100 + offsetX}px)`,
        }}
      >
        {twoRowData.map((item, index) => (
          <div className="create-item" key={index}>
            <Link href={`/product/${item.id}`}>
              <a>
                <MyImage
                  tag="v400"
                  className="create-item-thumb"
                  src={item.artworkUrl}
                />
              </a>
            </Link>
          </div>
        ))}
      </div>
    </StyledCreateModule>
  )
}
